var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDetailOpenIco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 80,
    viewBox: "0 0 24 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    width: 12,
    height: 80,
    rx: 6,
    fill: "currentColor"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.25106 39.4117C8.91631 39.7371 8.91631 40.2655 9.25106 40.5909L13.5358 44.756C13.8706 45.0813 14.4142 45.0813 14.7489 44.756C15.0837 44.4306 15.0837 43.9021 14.7489 43.5767L11.0694 40L14.7463 36.4233C15.081 36.0979 15.081 35.5694 14.7463 35.244C14.4115 34.9187 13.8679 34.9187 13.5331 35.244L9.24838 39.4091L9.25106 39.4117Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailOpenIco);
export default __webpack_public_path__ + "static/media/Detail_open_ico.f2536fd09ccd40e11dc3427d370c32b7.svg";
export { ForwardRef as ReactComponent };